import React from "react";
import type {
    PersonalisationItemType,
    PersonalizationType,
} from "../../../../../../common-deprecated/types/CommonTypes";
import * as Styles from "./styles/ItemList";
import { isLightColour } from "../../../../../../common-deprecated/utils";

type ItemPropsType<T> = {
    item: T;
    name?: string;
    hasBorder?: boolean;
    activeItemType: PersonalizationType;
};
const Item = <T extends { image: string; rgb?: string }>(props: ItemPropsType<T>): JSX.Element => {
    const { item, hasBorder, activeItemType, name } = props;
    const lightColour = !!item.rgb && isLightColour(item.rgb);
    return (
        <Styles.ItemWrapper hasBorder={hasBorder}>
            <Styles.ExteriorImage
                image={item.image}
                rgb={item.rgb}
                lightColour={lightColour}
                zoomedIn={activeItemType === "colour"}
            />
            <Styles.Text>{name}</Styles.Text>
        </Styles.ItemWrapper>
    );
};

export type ItemListPropsType = {
    items: PersonalisationItemType[];
    activeItemType: PersonalizationType;
    hasBorder?: boolean;
};

const ItemList = ({ items, activeItemType, hasBorder }: ItemListPropsType): JSX.Element => {
    return (
        <Styles.Wrapper>
            {items.map((item) => {
                return (
                    <Item
                        key={item.id}
                        item={item}
                        name={item.name || ""}
                        activeItemType={activeItemType}
                        hasBorder={hasBorder}
                    />
                );
            })}
        </Styles.Wrapper>
    );
};

export default ItemList;
